import { render, staticRenderFns } from "./lookBcCard.vue?vue&type=template&id=57da0444&scoped=true&"
import script from "./lookBcCard.vue?vue&type=script&lang=js&"
export * from "./lookBcCard.vue?vue&type=script&lang=js&"
import style0 from "./lookBcCard.vue?vue&type=style&index=0&id=57da0444&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57da0444",
  null
  
)

export default component.exports